module.exports = __webpack_public_path__ + "img/制御工学5_1_3.73a29002.png";